.card-content-empty {
    opacity: 0.75;
}
